import { getWebRtcStunnerConfig } from '@circuitry-ai/doc-data';

/**
 * Returns ICE servers for RTCPeerConnection (Stunner).
 * Config comes from `@circuitry-ai/doc-data`: env `CTY_WEBRTC_STUNNER_*` and/or `setVoiceAgentConfig`.
 */
export function getIceServers(): RTCIceServer[] {
  const stunner = getWebRtcStunnerConfig();
  if (!stunner && import.meta.env.DEV) {
    console.warn(
      '[webrtc] Set CTY_WEBRTC_STUNNER_HOST, CTY_WEBRTC_STUNNER_USER, and CTY_WEBRTC_STUNNER_CREDENTIAL (and/or pass webrtcStunner from setVoiceAgentConfig) for TURN/STUN.'
    );
  }
  if (!stunner) return [];

  const { host, username, credential } = stunner;
  return [
    { urls: `stun:${host}:3478` },
    {
      urls: [
        `turn:${host}:3478?transport=udp`,
        `turns:${host}:5349?transport=tcp`,
      ],
      username,
      credential,
    },
  ];
}

/**
 * Wait for ICE gathering to complete (or timeout) before sending the offer.
 */
export function waitForIceGatheringComplete(
  pc: RTCPeerConnection,
  timeoutMs = 2000
): Promise<void> {
  if (pc.iceGatheringState === 'complete') return Promise.resolve();
  return new Promise((resolve) => {
    const checkState = () => {
      if (pc.iceGatheringState === 'complete') {
        cleanup();
        resolve();
      }
    };
    const timeoutId = setTimeout(() => {
      cleanup();
      resolve();
    }, timeoutMs);
    const cleanup = () => {
      pc.removeEventListener('icegatheringstatechange', checkState);
      clearTimeout(timeoutId);
    };
    pc.addEventListener('icegatheringstatechange', checkState);
    checkState();
  });
}
